import chefPaul from "@/assets/chef-paul.jpg";
import hollyAvatar from "@/assets/holly-avatar.png";

const About = () => {
  return (
    <section id="about" className="section-padding bg-background">
      <div className="container-elegant">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent font-medium tracking-widest uppercase text-sm mb-3">
            The Chefs Make the Difference
          </p>
          <h2 className="heading-section text-foreground mb-4">
            Meet Our Team
          </h2>
          <div className="flex justify-center mb-6">
            <span className="text-accent text-3xl">⚜</span>
          </div>
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto">
            With over 30 years of combined culinary experience, our team delivers
            chef-driven menus, personalized service, and unforgettable flavors
            that celebrate your most special moments.
          </p>
        </div>

        {/* Team Cards */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          {/* Chef Paul */}
          <div className="card-elevated p-8 text-center group hover:shadow-lg transition-shadow duration-300">
            <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-accent/30">
              <img
                src={chefPaul}
                alt="Chef Paul"
                className="w-full h-full object-cover object-[center_25%] transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <h3 className="font-serif text-2xl font-semibold text-foreground mb-1">
              Chef Paul
            </h3>
            <p className="text-accent font-medium mb-4">Executive Chef</p>
            <p className="text-muted-foreground leading-relaxed text-sm">
              Chef Paul is a classically trained chef with deep Southern roots and a passion for mentorship, creativity, and culinary excellence. He apprenticed through the Atlanta Culinary Arts program at the prestigious Capital City Club under Chef Wolfgang Hippel, where he refined his technique and developed his signature approach to bold, story-driven cuisine.
            </p>
            <p className="text-muted-foreground leading-relaxed text-sm mt-3">
              Chef Paul competed internationally through Culinary Fight Club, later serving on its board for 15 years, helping shape the organization's competitive standards and culinary community. He went on to serve as Director of Culinary Development at the Atlanta Culinary Exchange, leading innovation, training, and menu development for chefs across the region.
            </p>
            <p className="text-muted-foreground leading-relaxed text-sm mt-3">
              A dedicated mentor, Chef Paul has apprenticed 73 emerging chefs through the 501(c)(3) organization Creative Life, championing hands-on education and professional growth. His style blends bold flavors, Southern hospitality, and meticulous execution — ensuring every plate tells a story.
            </p>
          </div>

          {/* Holly */}
          <div className="card-elevated p-8 text-center group hover:shadow-lg transition-shadow duration-300">
            <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-accent/30 bg-white">
              <img
                src={hollyAvatar}
                alt="Holly - Event Manager"
                className="w-full h-full object-contain object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <h3 className="font-serif text-2xl font-semibold text-foreground mb-1">
              Holly Crum
            </h3>
            <p className="text-accent font-medium mb-4">Head Event Designer</p>
            <p className="text-muted-foreground leading-relaxed text-sm">
              Holly Crum is a gifted event designer with a natural talent for transforming spaces and creating meaningful, beautifully curated experiences. She received her Event Planning Certificate from the University of Georgia, strengthening her foundation in design, logistics, and client‑centered planning.
            </p>
            <p className="text-muted-foreground leading-relaxed text-sm mt-3">
              Holly is known for her ability to bring warmth, precision, and creative styling to every event. Her instinct for detail and atmosphere allows her to elevate each celebration with thoughtful décor, cohesive aesthetics, and a seamless flow that reflects the client's vision.
            </p>
            <p className="text-muted-foreground leading-relaxed text-sm mt-3">
              At Gracious Gatherings, Holly leads event design with a blend of creativity and calm professionalism. She has shaped weddings, corporate events, and social gatherings across the region, coordinating décor, menus, and logistics with care to ensure every event feels intentional and unforgettable.
            </p>
            <p className="text-muted-foreground leading-relaxed text-sm mt-3">
              A dedicated partner to her clients, Holly approaches each project with heart, artistry, and an unwavering commitment to excellence — ensuring every celebration tells a story.
            </p>
          </div>
        </div>

        {/* Team Section */}
        <div className="mt-12 max-w-4xl mx-auto text-center">
          <div className="card-elevated p-8">
            <h3 className="font-serif text-2xl font-semibold text-foreground mb-4">
              Our Dedicated Team
            </h3>
            <p className="text-muted-foreground leading-relaxed text-lg">
              Gracious Gatherings has a full staff of Banquet Captains, Servers, and 
              Bartenders that have been a part of the Gracious Gatherings family for years. 
              Their event executions are flawless, bringing warmth, professionalism, and 
              attention to detail to every celebration we host.
            </p>
          </div>
        </div>

        {/* Promise Section */}
        <div className="mt-16 bg-muted/50 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto">
          <h3 className="font-serif text-2xl font-semibold text-foreground text-center mb-8">
            Our Promise to You
          </h3>
          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { title: "Quality First", desc: "Food quality is non-negotiable" },
              { title: "Warm Service", desc: "Professional yet personal attention" },
              { title: "Fair Pricing", desc: "Generous portions, responsible pricing" },
              { title: "Personal Care", desc: "Every event treated as our own" },
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <span className="text-accent text-xl mt-1">✓</span>
                <div>
                  <h4 className="font-semibold text-foreground">{item.title}</h4>
                  <p className="text-muted-foreground text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-foreground italic font-serif text-xl mt-8">
            "A venue with heart. A kitchen with soul."
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
